<template>
  <v-footer dark height="auto" class="footerFull">
    <v-container class="mainContainer footerFull__container">
      <v-layout row wrap>
        <!-- Contact Details -->
        <v-flex xs12 md4 class="footerFull__leftColumn">
          <ul>
            <li>
              <a
                href="/"
                @click="
                  () => {
                    submitLinkTracking('home')
                  }
                "
                class="footerFull__logo v-clean"
              >
                <CSSVGIcon
                  icon-name="careship-logo"
                  classes="icon__careshipLogo"
                />
              </a>
            </li>
            <li v-if="!isCGFunnel">
              <a
                href="tel:030220128839"
                @click="
                  () => {
                    submitLinkTracking('telephone')
                  }
                "
                class="footerFull__contact"
              >
                {{ translate('SPAN_FOOTER_TELEPHONE') }}
              </a>
            </li>
            <li v-if="!isCGFunnel">
              <span class="footerFull__contact">{{
                translate('FOOTER_WORKING_HOURS_LINE_1')
              }}</span>
            </li>
            <li v-if="!isCGFunnel">
              <span class="footerFull__contact">{{
                translate('FOOTER_WORKING_HOURS_LINE_2')
              }}</span>
            </li>
            <li v-if="!isCGFunnel">
              <a
                class="footerFull__contact"
                href="mailto:info@careship.de"
                >{{ translate('SPAN_FOOTER_EMAIL') }}</a
              >
            </li>
            <li v-if="isCGFunnel">
              <a
                href="tel:03056838277"
                @click="
                  () => {
                    submitLinkTracking('telephone')
                  }
                "
                class="footerFull__contact"
              >
                {{ translate('SPAN_FOOTER_TELEPHONE_CG_FUNNEL') }}
              </a>
            </li>
            <li v-if="isCGFunnel">
              <span class="footerFull__contact">{{
                  translate('OPENING_HOURS_SHORT_CG_FUNNEL')
                }}</span>
            </li>
            <li v-if="isCGFunnel">
              <a
                class="footerFull__contact"
                href="mailto:bewerbung@careship.de"
              >{{ translate('SPAN_FOOTER_EMAIL_CG_FUNNEL') }}</a
              >
            </li>
          </ul>
        </v-flex>

        <!-- Social Media -->
        <v-flex xs12 md4 class="footerFull__socialIcons text-md-center">
          <v-btn
            href="https://www.facebook.com/careship2015/"
            @click="submitLinkTracking('facebook')"
            class="footerFull__icon"
            target="_blank"
            icon
          >
            <CSSVGIcon
              icon-name="footer-social-fb"
              classes="icon__socialIcons"
            />
          </v-btn>

          <v-btn
            href="https://twitter.com/careship_de"
            @click="submitLinkTracking('twitter')"
            class="footerFull__icon"
            target="_blank"
            icon
          >
            <CSSVGIcon
              icon-name="footer-social-tw"
              classes="icon__socialIcons"
            />
          </v-btn>

          <v-btn
            href="https://www.instagram.com/careship/"
            @click="submitLinkTracking('instagram')"
            class="footerFull__icon"
            target="_blank"
            icon
          >
            <CSSVGIcon
              icon-name="footer-social-in"
              classes="icon__socialIcons"
            />
          </v-btn>
        </v-flex>

        <!-- Link List -->
        <v-flex xs12 md4 class="footerFull__list text-md-right">
          <ul>
            <li v-for="(link, index) in sideLinks" :key="index">
              <a
                :href="link.link"
                @click="
                  () => {
                    submitLinkTracking(link.description)
                  }
                "
                :target="link.isExternal ? '_blank' : ''"
                :title="link.text"
              >
                {{ link.text }}
              </a>
            </li>
          </ul>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider class="footerFull__divider hidden-sm-and-down"></v-divider>

    <v-container class="mainContainer footerFull__container">
      <v-layout column class="text-md-center">
        <div class="footerFull__list footerFull__citiesList text-md-center">
          <ul>
            <li v-for="(city, index) in orderedCities" :key="index">
              <a
                v-if="city.link"
                :href="city.link"
                @click="
                  () => {
                    submitLinkTracking(city.description)
                  }
                "
                :title="city.text"
                class="footerFull__city"
              >
                {{ city.text }}
              </a>
              <span v-else>{{ city.text }}</span>
            </li>
          </ul>
        </div>

        <div class="footerFull__copyright">
          <span>&copy;{{ new Date().getFullYear() }} Care Companion GmbH</span>
        </div>

        <div class="languageSwitch__container">
          <CSLanguageSwitch dark />
        </div>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'
import CSLanguageSwitch from '@/components/molecules/switch/CSLanguageSwitch.vue'
import _orderBy from 'lodash/orderBy'

export default {
  name: 'Footer',
  components: {
    CSLanguageSwitch,
    CSSVGIcon,
  },

  data() {
    return {
      sideLinks: [
        {
          description: 'about us',
          link: '/ueber-uns/',
          isExternal: false,
          text: this.translate('LINK_FOOTER_ABOUTUS'),
        },
        {
          description: 'guide',
          link: '/senioren-ratgeber/',
          isExternal: false,
          text: this.translate('LINK_FOOTER_GUIDE'),
        },
        {
          description: 'faq',
          link: '/faq/',
          isExternal: false,
          text: this.translate('LINK_FOOTER_FAQ'),
        },
        {
          description: 'apply as a caregiver',
          link: '/kunde/alltagshilfe/bewerbung',
          isExternal: true,
          text: this.translate('LINK_FOOTER_APPLYASACAREGIVER'),
        },
        {
          description: 'career',
          link: 'https://mycareship.jobs.personio.de/',
          isExternal: true,
          text: this.translate('LINK_FOOTER_CAREER'),
        },
        {
          description: 'imprint',
          link: '/impressum/',
          isExternal: false,
          text: this.translate('LINK_FOOTER_IMPRINT'),
        },
        {
          description: 'privacy',
          link: '/datenschutz/',
          isExternal: false,
          text: this.translate('LINK_FOOTER_DATAPROTECTION'),
        },
        {
          description: 'general terms of use',
          link: '/agb/',
          isExternal: false,
          text: this.translate('LINK_FOOTER_GENERALTERMSOFUSE'),
        },
        {
          description: 'hilfe',
          link: '/hilfe/',
          isExternal: false,
          text: this.translate('LINK_FOOTER_HELP'),
        },
        {
          description: 'press',
          link: '/newsroom',
          isExternal: false,
          text: this.translate('LINK_FOOTER_PRESS'),
        },
      ],
      cities: [
        {
          description: 'berlin',
          link: '/stadt/berlin/',
          text: this.translate('LINK_FOOTER_BERLIN'),
        },
        {
          description: 'hamburg',
          link: '/stadt/hamburg/',
          text: this.translate('LINK_FOOTER_HAMBURG'),
        },
        {
          description: 'essen',
          link: '/stadt/essen/',
          text: this.translate('LINK_FOOTER_ESSEN'),
        },
        {
          description: 'dresden',
          link: '/stadt/dresden/',
          text: this.translate('LINK_FOOTER_DRESDEN'),
        },
        {
          description: 'köln',
          link: '/stadt/koeln/',
          text: this.translate('LINK_FOOTER_KOELN'),
        },
        {
          description: 'münchen',
          link: '/stadt/muenchen/',
          text: this.translate('LINK_FOOTER_MUENCHEN'),
        },
        {
          description: 'stuttgart',
          link: '/stadt/stuttgart/',
          text: this.translate('LINK_FOOTER_STUTTGART'),
        },
        {
          description: 'frankfurt',
          link: '/stadt/frankfurt/',
          text: this.translate('LINK_FOOTER_FRANKFURT'),
        },
        {
          description: 'duesseldorf',
          link: '/stadt/duesseldorf/',
          text: this.translate('LINK_FOOTER_DUSSELDORF'),
        },
        {
          text: this.translate('LINK_FOOTER_LEIPZIG'),
        },
        {
          text: this.translate('LINK_FOOTER_DUISBURG'),
        },
        {
          text: this.translate('LINK_FOOTER_DORTMUND'),
        },
        {
          text: this.translate('LINK_FOOTER_POTSDAM'),
        },
        {
          text: this.translate('LINK_FOOTER_HANOVER'),
        },
        {
          text: this.translate('LINK_FOOTER_BOCHUM'),
        },
        {
          text: this.translate('LINK_FOOTER_NUREMBERG'),
        },
        {
          text: this.translate('LINK_FOOTER_BONN'),
        },
        {
          text: this.translate('LINK_FOOTER_BREMEN'),
        },
        {
          text: this.translate('LINK_FOOTER_MUENSTER'),
        },
        {
          text: this.translate('LINK_FOOTER_MANNHEIM'),
        },
        {
          text: this.translate('LINK_FOOTER_AND_MANY_MORE'),
        },
      ],
    }
  },

  computed: {
    orderedCities() {
      return _orderBy(this.cities, 'text')
    },
    isCGFunnel() {
      console.log(this.$route.name);
      return this.$route.name.includes('funnel') || this.$route.name.includes('cg-funel');
    }
  },

  methods: {
    submitLinkTracking(linkName) {
      this.$gtm.trackEvent({
        category: 'navigation',
        action: 'user clicked in the footer',
        label: linkName,
      })
    },
  },
}
</script>
